"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.caretMixin = exports.SelectSmall = exports.Select = exports.LargeSelect = void 0;

var _themeGet = require("@styled-system/theme-get");

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = require("../../Theme");

var _Box = require("../Box");

var _Flex = require("../Flex");

var _Spacer = require("../Spacer");

var _Text = require("../Text");

var _v = require("./tokens/v2");

var _v2 = require("./tokens/v3");

var _excluded = ["description", "disabled", "error", "focus", "hover", "id", "name", "options", "required", "selected", "title", "variant", "onSelect"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/** A drop-down select menu */
var Select = function Select(_ref) {
  var description = _ref.description,
      disabled = _ref.disabled,
      error = _ref.error,
      focus = _ref.focus,
      hover = _ref.hover,
      id = _ref.id,
      name = _ref.name,
      options = _ref.options,
      required = _ref.required,
      selected = _ref.selected,
      title = _ref.title,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "default" : _ref$variant,
      onSelect = _ref.onSelect,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _splitBoxProps = (0, _Box.splitBoxProps)(rest),
      _splitBoxProps2 = _slicedToArray(_splitBoxProps, 2),
      boxProps = _splitBoxProps2[0],
      selectProps = _splitBoxProps2[1];

  var tokens = (0, _Theme.useThemeConfig)({
    v2: {
      titleVariant: variant === "default" ? "text" : "small",
      titleTextTransform: null,
      secondaryTextVariant: "small"
    },
    v3: {
      titleVariant: "xs",
      titleTextTransform: "uppercase",
      secondaryTextVariant: "xs"
    }
  });
  return /*#__PURE__*/_react.default.createElement(_Box.Box, _extends({
    width: "100%"
  }, boxProps), /*#__PURE__*/_react.default.createElement(_Flex.Flex, _extends({
    as: "label"
  }, variant === "inline" ? {
    flexDirection: "row",
    alignItems: "center"
  } : {
    flexDirection: "column",
    alignItems: "flex-start"
  }, id ? {
    for: id
  } : {}), /*#__PURE__*/_react.default.createElement("div", null, title && /*#__PURE__*/_react.default.createElement(_Text.Text, {
    variant: tokens.titleVariant,
    lineHeight: variant === "inline" && description === undefined ? 1 : undefined,
    style: {
      textTransform: tokens.titleTextTransform
    }
  }, title, required && /*#__PURE__*/_react.default.createElement(_Box.Box, {
    as: "span",
    color: "brand"
  }, "*")), description && /*#__PURE__*/_react.default.createElement(_Text.Text, {
    variant: tokens.secondaryTextVariant,
    color: "black60"
  }, description)), (title || description) && /*#__PURE__*/_react.default.createElement(_Spacer.Spacer, {
    m: 0.5
  }), /*#__PURE__*/_react.default.createElement(Container, {
    variant: variant,
    disabled: disabled,
    hover: hover,
    error: error,
    focus: focus
  }, /*#__PURE__*/_react.default.createElement("select", _extends({
    id: id,
    disabled: disabled,
    name: name,
    value: selected,
    onChange: function onChange(event) {
      onSelect && onSelect(event.target.value);
    }
  }, selectProps), options.map(function (_ref2) {
    var value = _ref2.value,
        text = _ref2.text;
    return /*#__PURE__*/_react.default.createElement("option", {
      value: value,
      key: value
    }, text);
  })))), error && typeof error === "string" && /*#__PURE__*/_react.default.createElement(_Text.Text, {
    variant: tokens.secondaryTextVariant,
    mt: 0.5,
    color: "red100"
  }, error));
};

exports.Select = Select;
Select.displayName = "Select";
var resetMixin = (0, _styledComponents.css)(["appearance:none;background:none;border:none;outline:0;text-indent:0.01px;text-overflow:\"\";border-radius:0;&:-moz-focusring{color:transparent;text-shadow:0 0 0 black;}option:not(:checked){color:black;}"]);
/** Creates a small caret */

var caretMixin = (0, _styledComponents.css)(["&::after{content:\"\";cursor:inherit;width:0;height:0;position:absolute;top:50%;transform:translateY(-50%);right:", ";pointer-events:none;border-left:4px solid transparent;border-right:4px solid transparent;border-top:4px solid ", ";}"], (0, _themeGet.themeGet)("space.1"), function (_ref3) {
  var disabled = _ref3.disabled;
  return disabled ? (0, _themeGet.themeGet)("colors.black10") : (0, _themeGet.themeGet)("colors.black100");
});
exports.caretMixin = caretMixin;

var Container = _styledComponents.default.div.withConfig({
  displayName: "Select__Container",
  componentId: "sc-1weszjl-0"
})(["position:relative;width:100%;> select{", ";width:100%;padding:0 24px 0 ", ";font-family:", ";border:1px solid;cursor:pointer;line-height:1;transition:color 0.25s,background-color 0.25s,border-color 0.25s;", ";}", ""], resetMixin, (0, _themeGet.themeGet)("space.1"), (0, _themeGet.themeGet)("fonts.sans"), function (props) {
  var variants = (0, _Theme.getThemeConfig)(props, {
    v2: _v.SELECT_VARIANTS,
    v3: _v2.SELECT_VARIANTS
  });
  var states = variants[props.variant];
  return (0, _styledComponents.css)(["", " ", " ", " ", " ", " &:hover{", "}&:focus{", "}&:disabled{cursor:default;", "}"], states.default, props.hover && states.hover, props.focus && states.focus, props.disabled && states.disabled, props.error && states.error, states.hover, states.focus, states.disabled);
}, caretMixin);
/**
 * Default variant of Select. In v2 contexts this is the larger select.
 * @deprecated Use` <Select />`
 */


var LargeSelect = function LargeSelect(props) {
  return /*#__PURE__*/_react.default.createElement(Select, _extends({
    variant: "default"
  }, props));
};

exports.LargeSelect = LargeSelect;
LargeSelect.displayName = "LargeSelect";

/**
 * Inline variant of Select. In v2 contexts this is the smaller select.
 * @deprecated Use `<Select variant="inline">`
 */
var SelectSmall = function SelectSmall(props) {
  return /*#__PURE__*/_react.default.createElement(Select, _extends({
    variant: "inline"
  }, props));
};

exports.SelectSmall = SelectSmall;
SelectSmall.displayName = "SelectSmall";
//# sourceMappingURL=Select.js.map